import { MyParadiseOrderSummary } from "@app/components/myParadise/MyParadiseOrderSummary/MyParadiseOrderSummary"
import { useGetStrings } from "@app/store/service/cmsService"
import { useGetOrderHistory } from "@app/store/service/connectorService"
import { Modal } from "@tecreation/funnel-components"
import "./MyParadiseOrderHistoryModal.css"

const MyParadiseOrderHistoryModal = () => {
	const { data: orderHistory } = useGetOrderHistory()
	const { data: strings } = useGetStrings()
	const { orderHistoryModalTitle } = strings ? strings : {}

	if (orderHistory) {
		let orders = Array.from(orderHistory)
		return (
			<Modal className="historyModal w-100">
				<Modal.Closer />
				<Modal.Header>{orderHistoryModalTitle}</Modal.Header>
				<Modal.Body>
					<div className="f3 flex pb-4 color-bg-default top-0" style={{ position: "sticky" }}>
						<div className="flex-1 flex">Buchungsdatum</div>
						<div className="flex-1">Bestellnummer</div>
						<div className="flex-1">Besuchsdatum</div>
						<div className="flex-1">Betrag</div>
						<div style={{ width: "63px" }} />
					</div>

					{orders
						.sort((a, b) => {
							return new Date(b.creationDateTime) - new Date(a.creationDateTime)
						})
						.map(e => (
							<MyParadiseOrderSummary
								key={e.creationDateTime}
								webToken={e.webToken}
								orderNumber={e.orderCode}
								date={e.date}
								totalAmount={e.totalAmount}
								visitDates={e.tickets?.map(tck => tck.visitDate)}
							/>
						))}
				</Modal.Body>
			</Modal>
		)
	}
}
export default MyParadiseOrderHistoryModal
